export default "__VITE_ASSET__CdrAJcQT__"